<template>
	<div class="form-group">
		<div>
			<input type="checkbox" :name="name" :id="name" v-model="model" v-validate="rules" :data-vv-as="placeholder" :class="{ error: errors.has(name) }">
			<label :for="name" :class="{ error: errors.has(name) }"><slot></slot></label>
		</div>
		<span v-if="rules" v-show="errors.has(name)" class="text-danger">{{ errors.first(name) }}</span>
	</div>
</template>

<script>
export default {
	inject: ['$validator'],
	props: {
		value: {
			type: Boolean
		},
		name: {
			type: String
		},
		placeholder: {
			type: String
		},
		rules: {
			type: String
		}
	},
	computed: {
		model: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		},
		inputClass () {
			return {
				error: this.errors.has(name)
			}
		}
	}
}
</script>

<style scoped>
	.form-auth .form-group {
		padding: 10px 0 10px 0;
		margin: 0;
	}
	.form-auth .form-group > div {
		display: flex;
		flex-direction: row;
	}
	.form-auth .form-group > div > label {
		display: block;
		font-size: 12px;
		font-weight: 300;
		color: var(--main-color);
		text-align: left;
	}
	.form-auth .form-group > div > input {
		margin: 5px 15px 5px 0;
	}
	@media only screen and (max-width: 1025px)
	{
		.form-auth .form-group > div > input {
			margin: 2px 15px 5px 0;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/inputs/InputCheckbox.vue